import { lazy, Suspense } from 'react'
import { Switch, Redirect } from 'react-router-dom'
import SplashScreenPage from 'pages/SplashPage'
import ROUTE from 'constant/route'
import PermissionRoute from './PermissionRoute'
import useAdminRoute from './useAdminRoute'

const NotFound = lazy(() => import('pages/NotFoundPage'))

export default function AdminRoute() {
    const { adminRoutes } = useAdminRoute()

    return (
        <Suspense fallback={<SplashScreenPage />}>
            <Switch>
                <Redirect
                    exact
                    from={ROUTE.DEVICE_INTEGRATIONS}
                    to={ROUTE.DEVICE_INTEGRATIONS_NOTIFICATIONS}
                />
                <Redirect
                    exact
                    from={ROUTE.FINANCIAL_ACCOUNTING_CODES}
                    to={ROUTE.FINANCIAL_ACCOUNTING_CODES_GLCODE_TYPES}
                />
                <Redirect
                    exact
                    from={ROUTE.FINANCIAL_TAXES_SETTING_COMBINED_TAX}
                    to={ROUTE.FINANCIAL_TAXES_SETTING}
                />
                <Redirect
                    exact
                    from={ROUTE.FINANCIAL_TAXES_SETTING_SINGLE_TAX}
                    to={ROUTE.FINANCIAL_TAXES_SETTING}
                />
                {adminRoutes
                    .filter((a) => a.redirectToPath)
                    .map((r, idx) => {
                        return (
                            <Redirect
                                key={'redirect_' + idx}
                                exact
                                from={r.path}
                                to={r.redirectToPath!!}
                            />
                        )
                    })}
                {adminRoutes.map((cur) => {
                    return (
                        <PermissionRoute
                            key={cur.path}
                            exact={cur.exact ?? false}
                            path={cur.path}
                            component={cur.component}
                            permissions={cur.requirePermission}
                            operationalSetting={cur.moduleName}
                            terminalSetting={cur.terminalSetting}
                            visibleToClientType={cur.visibleToClientType}
                        />
                    )
                })}

                <PermissionRoute path="*" component={NotFound} />
            </Switch>
        </Suspense>
    )
}
